<template>
  <div class="reward-progress">
    <h3>{{ $t('member-information.key075') }}</h3>
    <p>{{ $t('member-information.key076') }}</p>
    <div class="reward">
      <div class="line" :style="{ '--line-width': lineWidth }">
        <div
          v-for="(item, index) in gifts"
          :key="index"
          class="dot"
          :class="{
            close: userData.quantityFilled < item.standard,
          }"
        ></div>
      </div>
      <div class="content">
        <div
          class="text"
          :class="{
            finish: index + 1 <= userData.collectionStage,
          }"
          :data-content="$t('member-information.key087')"
          v-for="(item, index) in gifts"
          :key="index"
        >
          <p class="textStep">{{ item.stepText }}</p>
          <img
            :src="`${$cloudFront}/Image/Public/sc/IPR9001.png`"
            alt=""
            :class="{
              close: userData.quantityFilled < item.standard,
              canClick: userData.quantityFilled >= item.standard && index + 1 > userData.collectionStage,
            }"
            @click="sendGift(index + 1, item.standard)"
          />
          <p class="item_name">{{ item.itemName }}</p>
          <p>x {{ item.quantity }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
// import { useRouter } from 'vue-router';
import { sendGift as sendGiftApi } from '@/api/apiService';
import { HttpStatusCode } from 'axios';

export default {
  name: 'MemberDisplay',

  setup() {
    const { t } = useI18n();
    const store = useStore();
    // const router = useRouter();
    const jwt = computed(() => store.state.jwt);

    const userData = inject('userData');
    const loading = inject('loading');

    const gifts = ref([
      {
        stepText: t('member-information.key077'),
        itemName: t('member-information.key080'),
        quantity: 2,
        standard: 3,
      },
      {
        stepText: t('member-information.key078'),
        itemName: t('member-information.key080'),
        quantity: 3,
        standard: 6,
      },
      {
        stepText: t('member-information.key079'),
        itemName: t('member-information.key080'),
        quantity: 5,
        standard: 9,
      },
    ]);

    const giftNamesMap = {
      IPR9001: t('member-information.key080'),
      // 其他 gift_id 映射可補在這裡
    };

    const lineWidth = computed(() => {
      const filled = userData.value.quantityFilled;
      const stage = userData.value.collectionStage;
      let filledPercentage = 0;
      let stagePercentage = 0;

      if (filled <= 2) filledPercentage = 5;
      else if (filled === 3) filledPercentage = 13;
      else if (filled <= 5) filledPercentage = 29;
      else if (filled === 6) filledPercentage = 45;
      else if (filled <= 8) filledPercentage = 61;
      else if (filled === 9) filledPercentage = 78;

      switch (stage) {
        case 1:
          stagePercentage = 13;
          break;
        case 2:
          stagePercentage = 45;
          break;
        case 3:
          stagePercentage = 78;
          break;
        default:
          stagePercentage = 0;
          break;
      }

      return stagePercentage >= filledPercentage ? `${stagePercentage}%` : `${filledPercentage}%`;
    });

    const sendGift = async (collectionStage, standard) => {
      const validStatus = collectionStage > userData.value.collectionStage && userData.value.quantityFilled >= standard;

      if (!validStatus) return;

      loading.value = true;

      const data = { collectionStage };

      try {
        const response = await sendGiftApi(data, jwt.value);
        const responseData = response.data.data;

        userData.value.collectionStage = responseData.collectionStage;

        const rewards = responseData.added_gifts.map((gift) => `${giftNamesMap[gift.gift_id] || gift.gift_id} x ${gift.quantity}`);

        const alertMessage = t('member-information.key082') + '\n' + rewards.join('\n');
        alert(alertMessage);

        store.commit('setTempUserInfo', null); // 清空暫存
      } catch (error) {
        if (error?.response?.status === HttpStatusCode.Forbidden) {
          alert('quantity filled not enough, does not match the collectionStage');
        } else if (error?.response?.status === HttpStatusCode.BadRequest) {
          console.error('incoming stage is not bigger than current stage');
        } else {
          console.error('Error sendGift:', error);
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      userData,
      gifts,
      lineWidth,
      sendGift,
    };
  },
};
</script>

<style lang="scss">
.reward-progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: #212121; */
  box-shadow: 0 2px 5px rgba(255, 255, 255, 0.2);
  padding: 10px;
  margin-bottom: 20px;

  h3 {
    font-size: 26px;
    font-weight: 400;
    text-align: center;
  }

  p {
    width: auto;
    text-align: center;
  }

  .reward {
    width: 100%;
    margin: 20px auto;
  }

  .line,
  .content {
    display: flex;
    justify-content: space-around;
    position: relative;

    .dot {
      width: 25px;
      height: 25px;
      background-color: #20bf55;
      border: 4px solid #323232;
      border-radius: 50%;
      z-index: 1;
    }

    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px;

      .textStep {
        color: #fff599;
      }

      .item_name {
        font-size: 12px;
      }

      img {
        cursor: pointer;
        max-width: 128px;

        &.canClick:hover {
          filter: drop-shadow(0px 0px 10px rgb(255, 255, 255));
        }
      }
    }

    .close {
      pointer-events: none;
      cursor: default;
      filter: grayscale(1);
    }

    .finish {
      position: relative;

      &::before {
        content: attr(data-content);
        //width: 100%;
        text-align: center;
        font-weight: 700;
        color: #ff0000;
        position: absolute;
        left: 50%;
        top: 46%;
        z-index: 2;
        transform: translate(-50%, -50%) rotate(-12deg);
        text-shadow: 1px 1px 2px #fff;
        line-height: 1.1;
        padding: 4px 6px;
        background-color: #ffffff81;
        border: 2px solid #ff0000;
        border-radius: 6px;
      }
    }
  }

  .line {
    &::after,
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 5%;
      transform: translateY(-50%);
      background-color: #323232;
      border-radius: 50px;
      width: 78%;
      height: 5px;
    }

    &::after {
      background-color: #20bf55;
      width: var(--line-width);
    }
  }
  @media (max-width: 441px) {
    .content .text img {
      width: 100%;
    }
  }
}
</style>
